<template>
	<div class="header clearfix">
		<div class="header-wrap">
			<div class="wrap">
				<div class="left fl">
					艺品天下
					<!-- <router-link to="/Index">
						<img src="https://caifung.oss-cn-hangzhou.aliyuncs.com/official/logo.svg">
						<img src="../assets/indexlogo.png" alt="">
					</router-link> -->
				</div>
				<div class="right fr clearfix">
					<ul class="clearfix fr">
						<li class="fl">
							<router-link to="/Index">
								<span>网站首页</span>
								<i></i>
							</router-link>
						</li>
						<li class="fl">
							<router-link to="/CustomProduct">
								<span>产品中心</span>
								<i></i>
							</router-link>
						</li>
						<li class="fl">
							<router-link to="/About">
								<span>解决方案</span>
								<i></i>
							</router-link>
						</li>
						<li class="fl">
							<router-link to="/Investment">
								<span>行业案例</span>
								<i></i>
							</router-link>
						</li>
						<li class="fl">
							<router-link to="/Activity">
								<span>联系我们</span>
								<i></i>
							</router-link>
						</li>
					</ul>

				</div>
			</div>
		</div>
		<div class="h-hight"></div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
			}
		},
		methods:{
		},
	}
</script>

<style scoped>
.header-wrap{
	position: fixed;
	top: 0;
	width: 100%;
  height: 100px;
	background: #fff;
	z-index: 999;
  box-shadow:0px 1px 10px 1px rgba(144,144,144,0.27);
}
.h-hight{
	height: 100px;
}
.wrap{
	width: 1200px;
	margin: 0 auto;
}
.header .left{
	width: 300px;
  margin-top: 15px;
  font-size: 30px;
}
.header .right{
	margin-top: 42px;
}
.header .right li{
	margin-left: 38px;
}
.header .right li a{
	font-size: 20px;
	color: #333333;
  line-height: 1px;
}
.header .right li a i{
	display: inline-block;
	width: 100%;
	height: 3px;
	margin-top: -10px;
}
.header .right li a.router-link-active,.header .right li a:hover{
	color: #3575E1;
}
/* .header .right li a:hover i,.header .right li a.router-link-active i{
	display: inline-block;
	width: 100%;
	height: 3px;
	background: #3575E1;
} */
.header .icon{
	width: 40px;
	height: 40px;
	margin-top: -15px;
	margin-left: 50px;
	background: url('https://caifung.oss-cn-hangzhou.aliyuncs.com/official/phone-icon.png') center no-repeat;
	position: relative;
	cursor: pointer;
	background-size: cover;
}
.header .icon:hover .text{
	display: block;
}
.header .icon .text{
	position: absolute;
	bottom: -92px;
	left: -210px;
	z-index: 99;
	background: #fff;
	text-align: center;
	width: 250px;
	height: 80px;
	line-height: 80px;
	display: none;
	box-shadow: 0px 1px 7px rgba(0,0,0,0.8);
	border-radius: 5px;
	font-size: 16px;
	color: #212773;
}
.header .icon .text:after{
 position: absolute;
 content: '';
 border-top: 10px transparent dashed;
 border-left: 10px transparent dashed;
 border-right: 10px transparent dashed;
 border-bottom: 10px #fff solid;
}

.header .icon .text:after{
 top: -20px; /*覆盖并错开1px*/
 right: 5px;
 border-bottom: 10px #fff solid;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue